import React, { useState, useEffect,useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Header, Input, Icon, Table,Form,Button } from "semantic-ui-react";
import { Formik, Field, Form as FormikForm } from "formik";
import complogo from "../../../image/RealBooks_Horizont_Logo.png"
import signupcontentbg from "../../../image/removebg-preview.png"
import verticalLogo from "../../../image/RealBooks_Vertical_Logo.png"
import "../components/compcreate.css"
import * as select from '../data/selector'
import {saveSignupCompCreateData,finalDomainCreation} from "../data/action";
import CompanyRegistration_one from "./companyRegistration_step1"
import CompanyRegistration_two from "./companyRegistration_step2"
import CompanyRegistration_three from "./companyRegistration_step3"
import CompanyRegistration_four from "./companyRegistration_step4"
import CompanyRegistration_five from "./companyRegistration_step5"
import { positions, Provider,useAlert } from "react-alert";
import { errorAlertOptions } from './customAlertOptions';
import { Base64 } from "js-base64";

const LayoutWithInstruction = (props) => {
    const dispatch = useDispatch();
    const alert = useAlert();
    const formsbmtref = useRef();
    let steponedisplay = props.curState == 5 ? "" : "none";
    let steptwodisplay = props.curState == 6 ? "" : "none";
    let stepthreedisplay = props.curState == 7 ? "" : "none";
    let stepfourdisplay = props.curState == 8 ? "" : "none";
    let stepfivedisplay = props.curState == 9 ? "" : "none";
    const [nextBtnClick,setnextBtnClick] = useState(false);
    const loginObj = useSelector(state => select.getLoginObject(state, props));
    // console.log("loginObj==",loginObj)
    const dataByemailId = useSelector(state => select.fetchedSignupCreateDataByEmail(state,props));
    const finalDomainCreationDataObj = useSelector(state => select.getfinalDomainCreationDataObj(state,props));
    const finalstepcomplete = useSelector(state => select.finalstepcomplete(state,props));
    /*Step five*/
    const [compNameErrorclass,setcompNameErrorclass] = useState("");
    const [customCompNameErrorMsg,setcustomCompNameErrorMsg] = useState("");  
    const [compSNameErrorclass,setcompSNameErrorclass] = useState("");
    const [customCompSNameErrorMsg,setcustomCompSNameErrorMsg] = useState("");  
    /*Step five Ends*/
    /*Step six*/
    const [cityErrorclass,setcityErrorclass] = useState("");
    const [cityErrorMsg,setcityErrorMsg] = useState(""); 
    const [countryErrorclass,setcountryErrorclass] = useState("");
    const [countryErrorMsg,setcountryErrorMsg] = useState(""); 
    const [stateErrorclass,setstateErrorclass] = useState("");
    const [stateErrorMsg,setstateErrorMsg] = useState(""); 
    const [selectedCountryCurrency,setselectedCountryCurrency] = useState("");
    /*Step six Ends*/
    /*Step seven*/
    const [currencyErrorclass,setcurrencyErrorclass] = useState("");
    const [currencyErrorMsg,setcurrencyErrorMsg] = useState(""); 
    const [gstinnoErrorclass,setgstinnoErrorclass] = useState("");
    const [gstinnoErrorMsg,setgstinnoErrorMsg] = useState(""); 
    const [gstinChkStat,setgstinChkStat] = useState(false);
    /*Step seven Ends*/
    /*Step eight*/
    const [refCodeErrorclass,setrefCodeErrorclass] = useState("");
    const [refCodeErrorMsg,setrefCodeErrorMsg] = useState(""); 
    const [termsErrorclass,settermsErrorclass] = useState("");
    const [termsErrorMsg,settermsErrorMsg] = useState("");
    const [industryErrorMsg,setindustryErrorMsg] = useState("");
    const [industryErrorclass,setindustryErrorclass] = useState("");
    const [industryotherErrorclass,setindustryotherErrorclass] = useState("");
    const [industryotherMsg,setindustryotherMsg] = useState("");
    const [termsConditionChk,settermsConditionChk] = useState(0);
    /*Step eight Ends*/
    const clickBackBtn = (e,values) => {
        if(props.curState == 5){
            props.setonbackClick(true)
            props.setCurState(1)
            props.setLayout(1)
        }else if(props.curState == 6){
            props.setonbackClick(true)
            props.setCurState(5)
            props.setLayout(2)
        }else if(props.curState == 7){
            props.setonbackClick(true)
            props.setCurState(6)
            props.setLayout(2)
        }else if(props.curState == 8){
            props.setonbackClick(true)
            props.setCurState(7)
            props.setLayout(2)
        }
    }
    useEffect(()=>{
        if(dataByemailId != undefined && props.onbackClick == false && nextBtnClick==true){
            if(dataByemailId.type == "success"){
                if(props.curState == 5){
                    props.setCurState(6);
                }else if(props.curState == 6){
                    props.setCurState(7);
                }else if(props.curState == 7){
                    props.setCurState(8);
                }
                setnextBtnClick(false)
            }
        }
        if(finalstepcomplete && props.curState == 8){
            if(finalDomainCreationDataObj?.type == "success"){
                // window.location.href = "/AMS-war/RlbAutoLoginAftrDomainCreate?loginToken="+finalDomainCreationDataObj?.sessionKey; 
                // window.location.href="http://ec2-3-7-170-219.ap-south-1.compute.amazonaws.com/AMS-war/Rlb_UsrLogin_AftrNwComp?compSname=AKG&adminid=2612&compid=3789&domain=marcopolo&redirectType=home"
                // props.setCurState(9);
                formsbmtref.current.submit();
            }else{
                alert.show('Ops! Company not created. Some error occured.',errorAlertOptions);
            }
        }
    })
    const saveSignup_Steps_Data = (values) => {
        // window.location.href="/AMS-war/Rlb_UsrLogin_AftrNwComp?compSname=AKG&adminid=2612&compid=3789&domain=marcopolo&redirectType=home"
        // console.log("values==",values)
        let regexStr = new RegExp('[0-9]{2}[a-zA-Z0-9]{10}[1-9A-Za-z]{1}[0-9A-Za-z]{2}')
        if(props.curState == 5 && (values.comp_name == null || values.comp_name == "")){
            setcompNameErrorclass("error")
            setcustomCompNameErrorMsg("Please provide company name")
        }else if(props.curState == 5 && (values.comp_short_name == null || values.comp_short_name == "")){
            setcompSNameErrorclass("error")
            setcustomCompSNameErrorMsg("Please provide company short name")
        }else if(props.curState == 6 && (values.country == null || values.country == "" || values.country == "Select Country")){
            setcountryErrorclass("error")
            setcountryErrorMsg("Please select country")
        }else if(props.curState == 6 && (values.state == null || values.state == "" || values.state == "Select State")){
            setstateErrorclass("error")
            setstateErrorMsg("Please select state")
        }else if(props.curState == 6 && (values.city == null || values.city == "" || values.city == "Select City")){
            setcityErrorclass("error")
            setcityErrorMsg("Please provide city")
        }else if(props.curState == 7 && gstinChkStat && (values.gstin_no == null || values.gstin_no == "")){
            setgstinnoErrorclass("error")
            setgstinnoErrorMsg("Please provide GSTIN Number")
        }else if(props.curState == 7 && gstinChkStat && (values.gstin_no != null && values.gstin_no != "" && !(regexStr.test(values.gstin_no)))){
            setgstinnoErrorclass("error")
            setgstinnoErrorMsg("Please provide GSTIN Number")
        }else if(props.curState == 7 && (values.currency == null || values.currency == "") && selectedCountryCurrency == ""){
            setcurrencyErrorclass("error")
            setcurrencyErrorMsg("Please provide currency")
        }else if(props.curState == 8 && (values.project_name == null || values.project_name == "" || values.project_name == "Select Industry")){
            setindustryErrorclass("error")
            setindustryErrorMsg("Please select the type of industry")
        }else if(props.curState == 8 && (values.project_name == "Others" && (values.industry_other == null || values.industry_other == ""))){
            setindustryotherErrorclass("error")
            setindustryotherMsg("Please provide other industry name")
        }else if(props.curState == 8 && termsConditionChk == 0){
            settermsErrorclass("error")
            settermsErrorMsg("Please accept terms and conditions")
        }else{
            setnextBtnClick(true)
            let newvalue ={...values}
            if(props.curState == 8){
                newvalue.terms_and_condition = termsConditionChk
            }
            if(selectedCountryCurrency != ""){
                newvalue.currency = selectedCountryCurrency
            }
            if(newvalue.project_name == "Others"){
                newvalue.project_name = newvalue.industry_other
            }
            if(props.curState > 6){
                if(newvalue.country == null || newvalue.country == ""){
                    newvalue.country = loginObj.country
                }
                if(newvalue.state == null || newvalue.state == ""){
                    newvalue.state = loginObj.state
                }
            }
            // console.log("newvalue=",newvalue)
            props.setonbackClick(false)         
            dispatch(saveSignupCompCreateData({
                data:newvalue,
                curState:props.curState
            }));
            if(props.curState == 8){
                dispatch(finalDomainCreation({
                    data:newvalue,
                    curState:props.curState
                }));
            }
        }
    }
    return (
        <div className="maincontainer">
            {/* {
                stepfivedisplay != "" ? */}
            <>
            <div className="aligncontainer">
                <div className="logocontainer">
                    <img src={complogo} className="compLogImg" />
                </div>
            </div>
            <div className="pageTitle">
                <div className="aligncontainer">
                    <Header as='h2' className="pagetitleText">Registration</Header>
                    <div className="submenucontainer">
                        <Header as='h6' size='tiny' className="submenu">home / registration</Header>
                    </div>
                </div>
            </div>
            <div className="aligncontainer">
                <div className="signUpWithHelpContainer">
                <Formik
                            size="large"
                            initialValues={loginObj}
                            // validationSchema={signup_Step_OneSchema}
                            onSubmit={(values) => saveSignup_Steps_Data(values)}
                            render={({
                            handleSubmit,
                            onChange,
                            values,
                            handleChange,
                            errors,
                            }) => (
                                <Form
                                    onSubmit={handleSubmit}
                                    as={FormikForm}
                                    className="CustomeForm"
                                    style={{ marginLeft: "5.25%" }}
                                > 
                                    <CompanyRegistration_one 
                                        displayparam={steponedisplay}
                                        values = {values}
                                        dataByemailId = {dataByemailId}
                                        clickBackBtn={clickBackBtn}
                                        compNameErrorclass={compNameErrorclass}
                                        setcompNameErrorclass={setcompNameErrorclass}
                                        customCompNameErrorMsg={customCompNameErrorMsg}
                                        setcustomCompNameErrorMsg={setcustomCompNameErrorMsg}
                                        compSNameErrorclass={compSNameErrorclass}
                                        setcompSNameErrorclass={setcompSNameErrorclass}
                                        customCompSNameErrorMsg={customCompSNameErrorMsg}
                                        setcustomCompSNameErrorMsg={setcustomCompSNameErrorMsg}
                                    />
                                    <CompanyRegistration_two 
                                        displayparam={steptwodisplay}
                                        values = {values}
                                        dataByemailId = {dataByemailId}
                                        clickBackBtn={clickBackBtn}
                                        cityErrorclass={cityErrorclass}
                                        setcityErrorclass={setcityErrorclass}
                                        cityErrorMsg={cityErrorMsg}
                                        setcityErrorMsg={setcityErrorMsg}
                                        countryErrorclass={countryErrorclass}
                                        setcountryErrorclass={setcountryErrorclass}
                                        countryErrorMsg={countryErrorMsg}
                                        setcountryErrorMsg={setcountryErrorMsg}
                                        stateErrorclass={stateErrorclass}
                                        setstateErrorclass={setstateErrorclass}
                                        stateErrorMsg={stateErrorMsg}
                                        setstateErrorMsg={setstateErrorMsg}
                                        selectedCountryCurrency={selectedCountryCurrency}
                                        setselectedCountryCurrency={setselectedCountryCurrency}
                                        selectedCountry={props.selectedCountry}
                                        setselectedCountry={props.setselectedCountry}
                                        selectedCountryId={props.selectedCountryId}
                                        setselectedCountryId={props.setselectedCountryId}
                                    />
                                    <CompanyRegistration_three 
                                        displayparam={stepthreedisplay}
                                        values = {values}
                                        dataByemailId = {dataByemailId}
                                        clickBackBtn={clickBackBtn}
                                        currencyErrorclass={currencyErrorclass}
                                        setcurrencyErrorclass={setcurrencyErrorclass}
                                        currencyErrorMsg={currencyErrorMsg}
                                        setcurrencyErrorMsg={setcurrencyErrorMsg}
                                        gstinnoErrorclass={gstinnoErrorclass}
                                        setgstinnoErrorclass={setgstinnoErrorclass}
                                        gstinnoErrorMsg={gstinnoErrorMsg}
                                        setgstinnoErrorMsg={setgstinnoErrorMsg}
                                        gstinChkStat={gstinChkStat}
                                        setgstinChkStat={setgstinChkStat}
                                        selectedCountryCurrency={selectedCountryCurrency}
                                        setselectedCountryCurrency={setselectedCountryCurrency}
                                        selectedCountry={props.selectedCountry}
                                        setselectedCountry={props.setselectedCountry}
                                    />
                                    <CompanyRegistration_four 
                                        displayparam={stepfourdisplay}
                                        values = {values}
                                        dataByemailId = {dataByemailId}
                                        clickBackBtn={clickBackBtn}
                                        refCodeErrorclass={refCodeErrorclass}
                                        setrefCodeErrorclass={setrefCodeErrorclass}
                                        refCodeErrorMsg={refCodeErrorMsg}
                                        setrefCodeErrorMsg={setrefCodeErrorMsg}
                                        termsErrorclass={termsErrorclass}
                                        settermsErrorclass={settermsErrorclass}
                                        termsErrorMsg={termsErrorMsg}
                                        settermsErrorMsg={settermsErrorMsg}
                                        termsConditionChk={termsConditionChk}
                                        settermsConditionChk={settermsConditionChk}
                                        setindustryErrorclass={setindustryErrorclass}
                                        setindustryErrorMsg={setindustryErrorMsg}
                                        industryErrorclass={industryErrorclass}
                                        industryErrorMsg={industryErrorMsg}
                                        industryotherErrorclass={industryotherErrorclass}
                                        setindustryotherErrorclass={setindustryotherErrorclass}
                                        industryotherMsg={industryotherMsg}
                                        setindustryotherMsg={setindustryotherMsg}
                                        recprops = {props}
                                    /> 
                                </Form>
                                )}
                            ></Formik>
                </div>
            </div>
            <div className="footerContainer">
                <div className="aligncontainer">
                    <Table basic='very'>
                        <Table.Row verticalAlign='top'>
                            <Table.Cell width={4}>
                                <div className="footerBlockContainer">
                                    <div className="footerInfo">
                                        <div className="footer-logo-wrap">
                                            <a href="https://realbooks.in/" className="footerLogo">
                                                <img alt="" src={verticalLogo} className="compVerticalLogo" />
                                            </a>
                                        </div>
                                        <a className="socialmediaCom" href="https://www.facebook.com/MyRealbooks/"><Icon name="facebook f" className="socialmediaIconCom" /></a>
                                        <a className="socialmediaCom" href="https://twitter.com/MyRealbooks"><Icon name="twitter" className="socialmediaIconCom" /></a>
                                        <a className="socialmediaCom" href="https://www.instagram.com/realbooks.online/?hl=en"><Icon name="instagram" className="socialmediaIconCom" /></a>
                                        <a className="socialmediaCom" href="https://www.linkedin.com/in/realbooks-online-491b8a156/"><Icon name="linkedin" className="socialmediaIconCom" /></a>
                                        <a className="socialmediaCom" href="http://bit.ly/RealBooks-YouTube"><Icon name="youtube" className="socialmediaIconCom" /></a>
                                    </div>
                                </div>
                            </Table.Cell>
                            <Table.Cell width={4}>
                                <div className="footerBlockContainer">
                                    <div className="h4 footerHeading">Important Links</div>
                                    <ul className="footerLink">
                                        <li><a href="https://login.realbooks.in">Login</a></li>
                                        <li><a href="https://realbooks.in/about/">About</a></li>
                                        <li><a href="https://realbooks.in/features/">Features</a></li>
                                        <li><a href="https://realbooks.in/why-realbooks/">Why RealBooks</a></li>
                                        <li><a href="https://realbooks.in/clients/">Our Clients</a></li>
                                        <li><a href="https://realbooks.in/partners/">Partner with us</a></li>
                                        <li><a href="https://realbooks.in/partners#locatePartner">Locate a Partner</a></li>
                                        <li><a href="https://realbooks.in#price">Pricing</a></li>
                                    </ul>
                                </div>
                            </Table.Cell>
                            <Table.Cell width={4}>
                                <div className="footerBlockContainer">
                                    <div className="widget">
                                        <div className="h4 footerHeading">Other links</div>
                                        <ul className="footerLink">
                                            <li><a href="https://realbooks.in/faq/">FAQs</a></li>
                                            <li><a href="https://realbooks.in/video/">Video Tutorials</a></li>
                                            <li><a href="https://realbooks.in/security/">Security</a></li>
                                            <li><a href="https://realbooks.in/privacy-policy/">Privacy Policy</a></li>
                                            <li><a href="https://realbooks.in/terms-and-conditions/">Terms &amp; Conditions</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </Table.Cell>
                            <Table.Cell width={4}>
                                <div className="footerBlockContainer">
                                    <div className="contactInfo">
                                        <div className="h4 footerHeading">Contact us</div>
                                        <span className="call"><a href="tel:+91-99108-22099"><Icon name="call" className="contactIconCom" />+91-99108-22099</a></span>
                                        <span className="email"><a href="mailto:support@realbooks.in"><Icon name="mail" className="contactIconCom" />support@realbooks.in</a></span>
                                        <a href="https://realbooks.in/contact.html" className="contactBtn Btn">Send us a message</a>
                                    </div>
                                </div>
                            </Table.Cell>
                        </Table.Row>
                    </Table>
                    <div className="copyrightTxt text-center">
                        <p>© Copyright
                            <script>
                                document.write(+new Date().getFullYear());
                            </script>2023 Adansa Solutions Private Limited. All Rights Reserved
                        </p>
                    </div>
                </div>
            </div>
            <form id="form_edit" method="post" action="/AMS-war/RlbAutoLoginAftrDomainCreate" target="" ref={formsbmtref}>
                <input type="hidden" name="loginToken" value={finalDomainCreationDataObj?.sessionKey}/>
            </form>
            </>
            {/* // :
            // <CompanyRegistration_five 
            //     displayparam={stepfivedisplay} />     */}
        {/* } */}
        </div>
    )
}
export default LayoutWithInstruction;